import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthDispatchContext } from "/src/features/auth/context/authContext";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import storage from "/src/utils/storage";
import client from "/src/services/client";

function SsoCallback() {
    const [searchParams] = useSearchParams();
    const authDispatchContext = useAuthDispatchContext();
    const toast = useToastDispatchContext();
    const navigate = useNavigate();

    useEffect(() => {
        const handleSsoCallback = async () => {
            const ssoSuccess = searchParams.get('sso_success');
            const jwt = searchParams.get('jwt');
            const refreshToken = searchParams.get('refresh_token');
            const error = searchParams.get('error');

            if (error) {
                const errorMessage = searchParams.get('message') || searchParams.get('error_description') || 'SSO authentication failed';
                toast.error('SSO Error', errorMessage, 5000);
                navigate('/login-sso-edf');
                return;
            }

            if (ssoSuccess === '1' && jwt) {
                try {
                    // Store JWT first so API calls are authenticated
                    storage('local').set('token', jwt);
                    if (refreshToken) {
                        storage('local').set('refresh_token', refreshToken);
                    }

                    // Fetch complete user info (company with bots/datasets/dashboards + permissions)
                    const [response, fetchError] = await client.get('user/info');

                    if (fetchError) {
                        console.error('SSO: Failed to fetch user info', fetchError);
                        toast.error('SSO Error', 'Failed to load user data', 5000);
                        storage('local').remove('token');
                        storage('local').remove('refresh_token');
                        navigate('/login-sso-edf');
                        return;
                    }

                    const { user, company, permissions } = response;

                    // Store data exactly like the normal login flow
                    storage('local').set('user', user);
                    storage('session').set('company', company);
                    storage('session').set('permissions', permissions);

                    authDispatchContext({
                        type: 'loginSuccess',
                        payload: {
                            token: jwt,
                            user: user,
                            refresh_token: refreshToken || null,
                        },
                    });

                    toast.success('SSO Success', `Welcome ${user.username || ''}!`, 3000);

                    navigate(urlWithRoutingCompany('home'));
                } catch (e) {
                    console.error('SSO callback error:', e);
                    toast.error('SSO Error', 'Failed to process authentication data', 5000);
                    navigate('/login-sso-edf');
                }
            }
        };

        handleSsoCallback();
    }, [searchParams, authDispatchContext, toast, navigate]);

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            fontSize: '18px',
            color: '#666'
        }}>
            Processing SSO authentication...
        </div>
    );
}

export default SsoCallback;
